module.exports = __webpack_public_path__ + "img/wave.9afca3da.png";